/**
 * Utility functions for managing the plan (planter grid) state
 */

/**
 * Removes planters (fioriere) from specified cells in the plan
 * @param {Array} plan - The plan 2D array (each cell has height, brothers, etc.)
 * @param {Array} occupiedCells - Array of {row, col} objects indicating cells to clear
 * @returns {Array} New plan with planters removed from specified cells
 */
export function clearPlantersFromCells(plan, occupiedCells) {
    if (!plan || !Array.isArray(plan) || !occupiedCells || occupiedCells.length === 0) {
        return plan;
    }

    return plan.map((planRow, r) =>
        planRow.map((cell, c) => {
            // Check if this cell should have its planter removed
            const shouldClear = occupiedCells.some(
                occupiedCell => occupiedCell.row === r && occupiedCell.col === c
            );

            if (shouldClear) {
                // Remove the planter by setting height to 0 and clearing brothers
                return { ...cell, height: 0, brothers: [] };
            }

            return cell;
        })
    );
}

/**
 * Checks if a furniture variant is a frame (telaio con ruote)
 * @param {Object} variant - The furniture variant object
 * @returns {boolean} True if the variant is a frame
 */
export function isFrame(variant) {
    return variant?.category === 'telaio_ruote';
}
